module.exports = __webpack_public_path__ + "static/wohlgensinger-a30213aa864d5f1d73a0f670360fb977.jpg";